
/**
 * Preload images
 *
 * @export
 * @class ImagePreload
 */
export default class ImagePreload {
  /**
   *Creates an instance of ImagePreload.
   * @param {Array.<String>} images
   * @memberof ImagePreload
   */
  constructor(images) {
    this.images = images;
  }

  /**
   * Load an image
   *
   * @static
   * @param {*} image
   * @returns
   * @memberof ImagePreload
   */
  static preloadImage(image) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = resolve;
      img.onerror = resolve; // TODO: Not handling errors - AH
      img.src = image;
    });
  }

  /**
   * Load the images
   *
   * @returns {Array.<Promise.<Event>>}
   * @memberof ImagePreload
   */
  loadAll() {
    return this.images.map(ImagePreload.preloadImage);
  }

  /**
   * Load the images
   *
   * @returns {<Promise.<Event>} resolves when all images are loaded
   * @memberof ImagePreload
   */
  load() {
    return Promise.all(this.loadAll());
  }
}
